import { render, staticRenderFns } from "./EKYCCustomerBankDetail.vue?vue&type=template&id=438828ae&"
import script from "./EKYCCustomerBankDetail.vue?vue&type=script&lang=js&"
export * from "./EKYCCustomerBankDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports